module.exports = __webpack_public_path__ + "img/likes.5b269886.png";